module.exports = __webpack_public_path__ + "fcf5f2c6ab65a5ae70a45f9f84affe2c.svg";


//////////////////
// WEBPACK FOOTER
// ./shared/images/plus.svg
// module id = 1002
// module chunks = 2